import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "lodash";

import { queryClient } from "App";
import { addResizedColumns } from "./useTableConfig";
import UserService from "services/User";
import { getCustomTablesAdminColumns } from "routes/custom_tables/settings/CustomTablesAdminColumnsAndFilters";
import { customTablesAdminKeys } from "routes/custom_tables/settings/queryKeys";

export const CUSTOM_TABLES_ADMIN_TABLE_CONSTANTS = {
  tableName: "custom_tables_admin",
  className: "custom_tables_admin",
  header: "Custom Tables",
  headerIcon: "table",
};

export const invalidateCustomTablesQuery = async () => {
  await Promise.all([
    // The root covers both the grid and its empty check.
    queryClient.invalidateQueries({ queryKey: customTablesAdminKeys.all }),
    queryClient.invalidateQueries({ queryKey: ["custom-tables-nav"] }),
  ]);
};

export const useCustomTablesAdminGrid = ({ onEdit, onDelete }) => {
  const { data: tableSettings, isSuccess: isTableSettingsFetched } = useQuery({
    queryKey: ["table-settings"],
    queryFn: UserService.getUserSettings,
  });

  const columns = useMemo(() => {
    if (!isTableSettingsFetched) return [];
    const initialColumns = getCustomTablesAdminColumns({ onEdit, onDelete });
    const settings = get(
      tableSettings,
      `user_settings.preferences.tables.${CUSTOM_TABLES_ADMIN_TABLE_CONSTANTS.tableName}`,
      {}
    );
    return addResizedColumns({
      columns: initialColumns,
      resizedColumns: settings?.resized_columns || {},
    });
  }, [tableSettings, isTableSettingsFetched, onEdit, onDelete]);

  return { columns, filters: [] };
};
